require('./dist/ng-sortable');
module.exports = 'as.sortable';



//////////////////
// WEBPACK FOOTER
// ./~/ng-sortable/index.js
// module id = 312
// module chunks = 0